export default "__VITE_ASSET__C6M1q7Lb__"